// src/utils/units.js

/**
  Mejora la visualización de la tabla de metadatos en el proposal
*/

// 1) Opciones Permitidas

export const UNIT_OPTIONS_BY_FIELD = {
  // Haz de partículas "Beam"
  beam_energy_units: ["eV", "keV", "MeV"],
  beam_current_units: ["A", "mA", "uA", "nA"],

  // Acelerador "Accelerator"
  injection_energy_units: ["eV", "keV", "MeV"],
  terminal_voltage_units: ["MV", "kV", "V"],
  magnetic_field_units: ["G"],
  electromagnet_current_units: ["A", "mA", "uA", "nA"],
  beam_shape_diameter_units: ["dm", "cm", "mm"],
  beam_shape_width_units: ["dm", "cm", "mm"],
  beam_shape_height_units: ["dm", "cm", "mm"],

  // Angles
  incident_angle_units: ["deg", "rad"],
  exit_angle_units: ["deg", "rad"],
  scattering_angle_units: ["deg", "rad"],

  // Filter
  filter_thickness_units: ["dm", "cm", "mm"],
  filter_diameter_units: ["dm", "cm", "mm"],
  detector_BIAS_voltage_units: ["MV", "kV", "V"],

  // Electronic Chains
  shaping_time_units: ["us", "ns"],
  peaking_time_units: ["us", "ns"],
  accumulated_charge_units: ["C", "mC", "uC", "nC"],
  detector_inverse_current_units: ["A", "mA", "uA", "nA"],
  sample_detector_distance_units: ["dm", "cm", "mm"],
  energy_detector_BIAS_voltage_units: ["MV", "kV", "V"],
  sample_energy_detector_distance_units: ["dm", "cm", "mm"],
  energy_shaping_time_units: ["us", "ns"],

  // MIC Scan Parameters
  scan_size_units: ["mm", "um", "nm"],
  time_per_pixel_units: ["ms/px", "us/px", "ns/px"],
  count_rate_units: ["Hz", "kHz", "MHz", "GHz"],

  // TOF ERDA
  sample_TOF_detector_distance_units: ["dm", "cm", "mm"],
  length_of_flight_units: ["dm", "cm", "mm"],
  TOF_station_BIAS_voltage_units: ["MV", "kV", "V"],
  TOF_TAC_range_units: ["us", "ns"],
  coincidence_window_units: ["us", "ns"],
};

// 2) Unidad Estandar
export const DEFAULT_UNITS = {
  // "Beam"
  beam_energy_units: "MeV",
  beam_current_units: "nA",

  // Acelerador "Accelerator"
  injection_energy_units: "MeV",
  terminal_voltage_units: "MV",
  magnetic_field_units: "G",
  electromagnet_current_units: "nA",
  beam_shape_diameter_units: "mm",
  beam_shape_width_units: "mm",
  beam_shape_height_units: "mm",

  // Angles
  incident_angle_units: "deg",
  exit_angle_units: "deg",
  scattering_angle_units: "deg",

  // Filter
  filter_thickness_units: "mm",
  filter_diameter_units: "mm",
  detector_BIAS_voltage_units: "V",

  // Electronic Chains
  shaping_time_units: "us",
  peaking_time_units: "us",
  accumulated_charge_units: "uC",
  detector_inverse_current_units: "nA",
  sample_detector_distance_units: "cm",
  energy_detector_BIAS_voltage_units: "V",
  sample_energy_detector_distance_units: "cm",
  energy_shaping_time_units: "ns",

  // MIC Scan Parameters
  scan_size_units: "um",
  time_per_pixel_units: "us/px",
  count_rate_units: "Hz",

  // TOF ERDA
  sample_TOF_detector_distance_units: "cm",
  length_of_flight_units: "cm",
  TOF_station_BIAS_voltage_units: "V",
  TOF_TAC_range_units: "ns",
  coincidence_window_units: "ns",
};

const UNIT_FACTORS = {
  // Energy eV <-> keV <-> MeV
  energy: { eV: 1, keV: 1e3, MeV: 1e6 },

  // Current A <-> mA <-> uA <-> nA
  current: { A: 1, mA: 1e-3, uA: 1e-6, nA: 1e-9 },

  // Voltage:
  voltage: { V: 1, kV: 1e3, MV: 1e6 },

  //Angles:
  angles: { deg: "deg", rad: "rad" },

  // Length
  length: { nm: 1e-9, um: 1e-6, mm: 1e-3, cm: 1e-2, dm: 1e-1, m: 1 },

  // Time
  time: { us: 1e-6, ns: 1e-9 },

  // Charge
  charge: { C: 1, mC: 1e-3, uC: 1e-6, nC: 1e-9 },

  // Pixel per time
  pixel: { "ms/px": 1e-3, "us/px": 1e-6, "ns/px": 1e-9 },

  // Rate
  rate: { Hz: 1, kHz: 1e3, MHz: 1e6, GHz: 1e9 },
};

const UNIT_FIELD_KIND = {
  beam_energy_units: "energy",
  beam_current_units: "currente",
  injection_energy_units: "energy",
  terminal_voltage_units: "voltage",
  magnetic_field_units: "magnetic",
  electromagnet_current_units: "currente",
  beam_shape_diameter_units: "length",
  beam_shape_width_units: "length",
  beam_shape_height_units: "length",
  incident_angle_units: "angle",
  exit_angle_units: "angle",
  scattering_angle_units: "angle",
  filter_thickness_units: "length",
  filter_diameter_units: "length",
  detector_BIAS_voltage_units: "voltage",
  shaping_time_units: "time",
  peaking_time_units: "time",
  accumulated_charge_units: "charge",
  detector_inverse_current_units: "current",
  sample_detector_distance_units: "length",
  energy_detector_BIAS_voltage_units: "voltage",
  sample_energy_detector_distance_units: "length",
  energy_shaping_time_units: "time",
  //scan_size_units: "length",
  time_per_pixel_units: "pixel",
  count_rate_units: "rate",
  sample_TOF_detector_distance_units: "length",
  length_of_flight_units: "length",
  TOF_station_BIAS_voltage_units: "voltage",
  TOF_TAC_range_units: "time",
  coincidence_window_units: "time",
};

// ------------------------------
// Conversion
// ------------------------------

export function convertByFactor(value, fromUnit, toUnit, factorMap) {
  if (value == null || value === "") return value;

  const n = Number(value);
  if (Number.isNaN(n)) return null;

  const fromFactor = factorMap[fromUnit];
  const toFactor = factorMap[toUnit];

  if (fromFactor == null || toFactor == null) return value;
  const baseValue = n * fromFactor;
  return baseValue / toFactor;
}

function convertAngle(value, fromUnit, toUnit) {
  if (value == null || value === "") return value;
  const n = Number(value);
  if (Number.isNaN(n)) return value;

  if (fromUnit === toUnit) return n;

  if (fromUnit === "deg" && toUnit === "rad") return (n * Math.PI) / 180;
  if (fromUnit === "rad" && toUnit === "deg") return (n * 180) / Math.PI;

  return value;
}

export function convertValue(value, fromUnit, toUnit, kind) {
  if (!fromUnit || !toUnit || !kind) return value;
  if (fromUnit === toUnit) return value;

  if (kind === "angle") return convertAngle(value, fromUnit, toUnit);

  const factorMap = UNIT_FACTORS[kind];
  if (!factorMap) return value;

  return convertByFactor(value, fromUnit, toUnit, factorMap);
}

// Dado "beam_energy_units" devuelve:
// - valueField = "beam_energy"
// - unitField = "beam_energy_units"

function getValueFieldFromUnitField(unitField) {
  return unitField.replace(/_units$/, "");
}

// Normaliza UN file (objeto)
export function normalizeFileUnits(file, options = {}) {
  const { defaultUnits = DEFAULT_UNITS, onlyKnownFields = true } = options;

  if (!file || typeof file !== "object") return file;

  const copy = { ...file };

  // recorremos todas las keys que terminen en _units
  Object.keys(copy).forEach((unitField) => {
    if (!unitField.endsWith("_units")) return;

    // si quieres solo los campos que has definido en DEFAULT_UNITS
    if (onlyKnownFields && !(unitField in defaultUnits)) return;

    const valueField = getValueFieldFromUnitField(unitField);

    const fromUnit = copy[unitField];
    const toUnit = defaultUnits[unitField];

    // si no hay valor o unidad, no tocamos
    if (copy[valueField] == null) return;
    if (!fromUnit || !toUnit) return;

    const kind = UNIT_FIELD_KIND[unitField];

    // si no sabemos el tipo, no convertimos (pero podemos forzar unidad)
    if (!kind) {
      copy[unitField] = toUnit;
      return;
    }

    const converted = convertValue(copy[valueField], fromUnit, toUnit, kind);

    copy[valueField] = converted;
    copy[unitField] = toUnit;
  });

  return copy;
}

// Normaliza lista de files
export function normalizeFilesUnits(files, options = {}) {
  if (!Array.isArray(files)) return files;
  return files.map((f) => normalizeFileUnits(f, options));
}

// Devuelve la unidad que se mostrará en header (según default)
export function getDisplayUnit(unitField, defaultUnits = DEFAULT_UNITS) {
  return defaultUnits?.[unitField] || "";
}
